"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADMIN_SUBMISSION_SYNC_VIDEOS_MUTATION = exports.AdminSubmissionSyncVideosInputGql = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.AdminSubmissionSyncVideosInputGql = (0, graphql_tag_1.default) `
  input AdminSubmissionSyncVideosInput {
    id: String!
    syncType: String!
  }
`;
exports.ADMIN_SUBMISSION_SYNC_VIDEOS_MUTATION = (0, graphql_tag_1.default) `
  mutation synchroniseVideos($input: AdminSubmissionSyncVideosInput!) {
    adminSubmissionSyncVideos(input: $input) {
      id
    }
  }
`;
